export default __webpack_public_path__ + "static/media/5_4_hl.9f0bee30.png";